import React, { useState } from 'react'

import { TbRewindForward40 } from "react-icons/tb";
import { MdCurrencyRupee } from "react-icons/md";
import { GoPasskeyFill } from "react-icons/go";
import { MdOutlinePayments } from "react-icons/md";
import { TbRewindBackward60 } from "react-icons/tb";
import { FaCircleHalfStroke } from "react-icons/fa6";
import { BsFillHouseGearFill } from "react-icons/bs";
import { PiBuildingFill } from "react-icons/pi";
import { PiBuildingApartmentFill } from "react-icons/pi";

import heroImg from '../../../../assets/bhutani/Studio/studioHero.jpg'
import inner1 from '../../../../assets/bhutani/Studio/studio-1.jpg'
import inner2 from '../../../../assets/bhutani/Studio/studio-2.jpg'
import inner3 from '../../../../assets/bhutani/Studio/studio-3.jpg'
import inner4 from '../../../../assets/bhutani/Studio/studio-4.jpg'
import inner5 from '../../../../assets/bhutani/Studio/studio-5.jpg'

import { ImageModal } from '../../../common/ImageModal';
import { ConnectForm } from '../../../common/ConnectForm';


const Apartments = () => {
    const [openImgModal, setOpenImgModal] = useState(false)
    const innerImgs = [inner1, inner2, inner3, inner4, inner5]

    const points = [
        {
            icon: PiBuildingApartmentFill,
            title: 'Fully Furnised/Loaded Luxury Apartment',
        },
        {
            icon: GoPasskeyFill,
            title: 'Lease Guarantee of Rs.175 / sqft',
        },
        {
            icon: BsFillHouseGearFill,
            title: 'Total -294 Studio',
        },
        {
            icon: FaCircleHalfStroke,
            title: 'Lease - Revenue Share(50 %)',
        },
        {
            icon: MdOutlinePayments,
            title: 'Loan Available',
        },
        {
            icon: PiBuildingFill,
            title: 'Total Floors - G+19',
        },
        {
            icon: MdCurrencyRupee,
            title: 'Payment Plan- 40:60',
        },
        {
            icon: TbRewindForward40,
            title: '40% on Booking',
        },
        {
            icon: TbRewindBackward60,
            title: '60% in 18 months',
        }
    ]


    return (
        <div className="w-full min-h-screen bg-gray-100">
            <div
                className="w-full h-[500px] bg-cover bg-center mb-5"
                style={{ backgroundImage: `url('${heroImg}')` }}
            ></div>

            <div class="flex flex-col md:flex-row px-2.5 gap-4">
                <div class="w-full md:w-2/3 flex flex-col gap-4">
                    <div class="">
                        <div className="max-w-5xl mx-auto p-6">
                            <p className="text-md text-gray-700 mb-4 text-justify">The Luxury Fully Furnished Studio Apartments at Bhutani City Center 32 in Noida Sector 32 offer an unparalleled
                                living experience that seamlessly blends modern elegance with ultimate convenience. These studio apartments are
                                designed to cater to the sophisticated tastes of urban dwellers, providing a perfect blend of comfort, style, and
                                functionality.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> Each studio apartment is meticulously crafted with high-end finishes and premium materials. The interiors feature
                                modern furniture, tasteful flooring, and exquisite lighting, creating a luxurious ambiance that elevates everyday
                                living.</p>
                            <p className="text-md text-gray-700 mb-4 text-justify"> Residents can enjoy a host of world-class amenities, including a state-of-the-art gymnasium, swimming pools, indoor
                                games, a food court, and a spa. The apartments are part of a secure and gated community, offering 24/7 security and
                                CCTV surveillance for peace of mind. The location within the bustling City Center mall provides easy access to
                                shopping, dining, and entertainment options, making it an ideal place for both families and professionals.</p>
                        </div>
                        <div className="max-w-4xl mx-auto p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {points.map((point, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center bg-white p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300"
                                    >
                                        {React.createElement(point.icon, {
                                            size: 24,
                                            color: "green",
                                            className: "w-6 h-6 mr-3",
                                        })}
                                        <span className="text-gray-700 font-medium">{point.title}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <ConnectForm />
            </div>
            {openImgModal && (
                <ImageModal images={innerImgs} openImg={openImgModal} />
            )}
            <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 p-4">
                {innerImgs.map((data, index) => (
                    <div
                        key={index}
                        onClick={() => setOpenImgModal(true)}
                        className="w-full mx-auto rounded-md shadow-md overflow-hidden bg-white"
                    >
                        <img src={data} alt="Bhutani"
                            className="w-full h-full rounded-md shadow-md overflow-hidden bg-white object-cover transition-transform duration-300 transform hover:scale-105"
                        />
                    </div>
                ))}
            </div>

        </div>
    )
}
export default Apartments;